import React, { useEffect } from 'react';
// import { NotificationsOutlined } from '@mui/icons-material';
import {
  Box,
  Container,
  Divider,
  // IconButton,
  Skeleton,
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
// import Colors from '../../../../Configs/colors';
import Images from '../../../../Configs/images';
import ROUTES from '../../../../Configs/routes';
import { getCourierRequests } from '../../../../Redux/Models/request';
import Elements from '../../../Elements';
import { getTotalItems } from '../../../../Utils/helpers';

export default function Home({ classes, data, isLoading }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCourierRequests());
  }, []);

  const renderRequests = () => {
    if (isLoading) {
      return (
        <section className="request-container">

          <Container className="mt-3">
            {[1, 2, 3].map((i) => (
              <Box sx={{ mb: 1 }} className="tracking-box" key={i}>
                <div className="flex align-items-center space-between">
                  <Skeleton variant="rectangular" width={84} height={22} style={{ borderRadius: 11 }} />
                  <Skeleton variant="rectangular" width={60} height={18} style={{ borderRadius: 11 }} />
                </div>
                <div className="flex space-between mt-2">
                  <div style={{ width: '65%' }}>
                    <Skeleton variant="text" width="100%" />
                    <Skeleton variant="text" width="60%" />
                  </div>
                  <div>
                    <Skeleton variant="text" width={80} />
                    <Skeleton variant="text" width={80} />
                  </div>
                </div>
              </Box>
            ))}
          </Container>
        </section>
      );
    }
    if (data?.length) {
      return (
        <section className="request-container">
          <Container className="mt-3">
            {/* <Box bgcolor="#fff" borderRadius={8}> */}
            {data.map((req) => (
              <Box
                key={req.id}
                sx={{ mb: 1 }}
                className="tracking-box"
                onClick={() => navigate(`${ROUTES.request()}/${req.id}`)}
              >
                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Box display="inline-flex" flexDirection="column" alignItems="center">
                    <img src={req.type === 'Request In' ? Images.OenoIn : Images.OenoOut} alt={req.type} width="28" height="28" />
                    <div className="weight-700 s-12 mt-1 primary-green">
                      {req.type}
                    </div>
                  </Box>
                  <Box textAlign="right">
                    <Box>
                      <Box bgcolor="#D9EDFC" fontSize={14} fontWeight="700" color="#2391D9" py="2px" px={1} borderRadius="4px">{req.status}</Box>
                    </Box>
                    <Box
                      display="flex"
                      gap={0.5}
                      mt={1}
                      alignItems="center"
                      justifyContent="flex-end"
                    >
                      <img alt="delivery" width="24" height="24" src={req.delivery_type?.icon === 'warehouse' ? Images.IconHome : Images.IconDelivery} />
                      <Box fontWeight="700" fontSize={12}>{req.delivery_type?.name || 'Regular'}</Box>
                    </Box>
                  </Box>
                </Box>
                <Divider sx={{ my: 2 }} />
                <div className="flex-1">
                  <div className="flex space-between">
                    <div className="flex-1">
                      <div className="mute s-12">Customer name</div>
                      <div className="weight-700 mt-1">{req.pickup_address?.name}</div>
                    </div>
                    <div className="flex-1">
                      <div className="mute s-12">Total items</div>
                      <div className="weight-700 mt-1">
                        {
                          getTotalItems(req)
                        }
                      </div>
                    </div>
                    <div className="flex-1">
                      <div className="mute s-12">Delivery Date</div>
                      <div className="weight-700 mt-1">{moment(new Date(req.pickup_date)).format('DD MMM YYYY, HH.mm')}</div>
                    </div>
                  </div>
                </div>
              </Box>
            ))}
            {/* </Box> */}
          </Container>
        </section>
      );
    }

    return (
      <Box className="center" mt={12}>
        <img src={Images.EmptyBox} alt="No result" />
        <div className="mt-3 height-14">
          <Box className="weight-700" color="#2E3C40" fontSize={18}>No Available Request Task Right Now</Box>
          <Box className="height-16 s-16 mt-1" color="#404852">
            You doing great completed all task requests!
          </Box>
        </div>
      </Box>
    );
  };

  return (
    <Elements.CourierPageBase>
      <section className={`${classes.linearSection} sticky`}>
        <Container>
          <div className="flex space-between align-items-center">
            <h1>
              <img src={Images.LogoWhite} alt="Oeno Bank" height={36} />
            </h1>
          </div>
          <Box className="flex space-between" mt={10}>
            <Box>
              <Box className="headline">
                Your Available Request Task
              </Box>
              <Box fontWeight="400" fontSize={12} color="#FDFDFD">
                {data.length || 0}
                {' '}
                request task
              </Box>
            </Box>
          </Box>
        </Container>
      </section>

      <div className={classes.root}>
        {renderRequests()}
      </div>
    </Elements.CourierPageBase>
  );
}
